import { useCallback, useEffect } from 'react';

import { type BaseAIAction, useAIContext } from '@atlassian/ai-smart-button-api';

import { useConversationActionsStoreActions } from '@confluence/conversation-assistant/entry-points/conversation-assistant';

import {
	useConfluenceRovoButtonActions,
	useConfluenceRovoButtonEditorActions,
	useConfluenceRovoButtonConsumptionActions,
} from '../ConfluenceRovoButtonStore';
import { mapActionsToConversationActions } from '../utils/mapToConversationActions';

export const useAIActions = () => {
	const context = useAIContext();
	const { setConversationActions } = useConversationActionsStoreActions();
	const { setEditorActions: setEditorActionsInStore, setConsumptionActions } =
		useConfluenceRovoButtonActions();
	const editorActions = useConfluenceRovoButtonEditorActions();
	const consumptionActions = useConfluenceRovoButtonConsumptionActions();

	const setEditorActions = useCallback(
		(actions: BaseAIAction[]) => {
			setEditorActionsInStore(mapActionsToConversationActions(actions));
		},
		[setEditorActionsInStore],
	);

	useEffect(() => {
		/**
		 * When there is selection in editor, sourceId will be 'editor' and reference will be present.
		 * So show only editor actions.
		 */
		if (context?.sourceId === 'editor' && context?.reference) {
			setConversationActions(editorActions);
		} else {
			setConversationActions([...editorActions, ...consumptionActions]);
		}

		return () => {
			setConversationActions([]);
		};
	}, [context, consumptionActions, editorActions, setConversationActions]);

	return {
		setEditorActions,
		setConsumptionActions,
	};
};
